module.exports = __webpack_public_path__ + "img/conclusion4.a23d5cc6.png";